import { Component, Input, HostBinding } from '@angular/core';

@Component({
  selector: 'app-step',
  templateUrl: './step.component.html',
  styleUrls: ['./step.component.sass'],
})
export class StepComponent {
  @Input() name: string;
  @Input() stepNumber: number;
  @Input() @HostBinding('class.active') isActive: boolean;
  @Input() hasLine: boolean;
  @Input() selected: boolean;
}
